<template>
	<SectionContainer
		ref="sectionContainer"
		:isExpandable="true"
		class="parts-locations-signature"
	>
		<template #left>
			<h4>Signature Capture Methops</h4>
			<p>Lorem ipsum description text</p>
		</template>
		<template #right>
			<div v-if="editMode">
				<Button
					className="btn--icon-only"
					iconClassName="icon-unsaved"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-close"
					:iconBeforeLabel="true"
					:btnClick="handleEditMode"
				/>
			</div>
			<Button
				v-if="!editMode"
				className="btn--icon-only"
				iconClassName="icon-edit"
				:iconBeforeLabel="true"
				:btnClick="handleEditMode"
			/>
		</template>
		<template #content>
			<PartsLocationsSignatureCard v-if="!editMode" />
			<PartsLocationsSignatureCardEdit v-model="localData" v-else />
			<Modal
				:display="true"
				:isConfirmation="true"
				v-if="closeWithOutSaving"
			>
				<template #modal-content>
					Are you sure you want to close this section without saving?
				</template>
			</Modal>
		</template>
	</SectionContainer>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import Button from '@/components/forms/button/button';
import Modal from '@/components/shells/modal/modals';
// import HorizontalScrolling from '@/components/shells/horizontal-scrolling/horizontal-scrolling';
import PartsLocationsSignatureCard from './parts-locations-signature-card.vue';
import PartsLocationsSignatureCardEdit from './parts-locations-signature-card-edit.vue';
import _ from 'lodash';

export default {
	name: 'PartsLocationsSignature',
	components: {
		SectionContainer,
		Button,
		Modal,
		PartsLocationsSignatureCard, //comment when HorizontalScrolling is ready
		//HorizontalScrolling
		PartsLocationsSignatureCardEdit
	},
	props: {
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.data),
			closeWithOutSaving: false,
			editMode: false
		};
	},
	methods: {
		handleEditMode() {
			this.editMode = !this.editMode;
		}
	},
	watch: {
		localData: {
			deep: true,
			handler(newValue) {
				console.log(newValue);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.parts-locations-signature {
	&__items,
	&__items-edit-mode {
		display: flex;
		gap: $gutter-md;
	}

	h4 {
		margin-block-start: 0;
		margin-block-end: 0;
	}
}
</style>
